__turbopack_context__.v({
  "header": "uiM3gq_header",
  "sortingInputWrapper": "uiM3gq_sortingInputWrapper",
  "sortingLabel": "uiM3gq_sortingLabel",
  "title": "uiM3gq_title",
  "wrapper": "uiM3gq_wrapper",
});
